export default "__VITE_ASSET__GQGEnISn__"